import React from 'react';
import Switch from '../switch/switch';
import {
    SwitchWithInfoContainer,
    ContentWrapper,
    Label,
    InfoText,
} from './switch-with-info.style';

interface SwitchWithInfoProps {
    label: string;
    info: string;
    value: boolean;
    onChange: (value: boolean) => void;
    id?: string;
    disabled?: boolean;
}

const SwitchWithInfo: React.FC<SwitchWithInfoProps> = ({
    label,
    info,
    value,
    onChange,
    id,
    disabled = false,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return (
        <SwitchWithInfoContainer>
            <ContentWrapper>
                <Label>{label}</Label>
                <Switch
                    value={value}
                    onChange={handleChange as any}
                    id={id}
                    disabled={disabled}
                />
            </ContentWrapper>
            <InfoText>{info}</InfoText>
        </SwitchWithInfoContainer>
    );
};

export default SwitchWithInfo;
